// extracted by mini-css-extract-plugin
export default {"avatarContainer":"GlobalLeaderboard_avatarContainer__5MgEL","rowsContainer":"GlobalLeaderboard_rowsContainer__FzW1F"};